(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-trust-tabs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-product-info-extras] [role="tab"]');
    if (!tab) return;

    var root = tab.closest('[data-product-info-extras]');
    var tabs = Array.from(root.querySelectorAll('[role="tab"]'));

    tabs.forEach(function (item) {
      var active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', String(active));
      item.setAttribute('tabindex', active ? '0' : '-1');
      root.querySelector('#' + item.getAttribute('aria-controls')).hidden = !active;
    });
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest('[data-product-info-extras] [role="tab"]');
    if (!tab) return;

    var root = tab.closest('[data-product-info-extras]');
    var tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    var index = tabs.indexOf(tab);
    var next = index;

    if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
    if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = tabs.length - 1;

    if (next !== index) {
      event.preventDefault();
      tabs[next].focus();
      tabs[next].click();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
